import { History } from 'history';
import { action, mutatorAction } from 'satcheljs';
import {
  IReportItem,
  IReportSection,
  ISavedReportItem,
  MY_REPORT_SECTION_ID,
} from '../../components/LeftHandNavigation/LeftHandNavigation.types';
import { getPageStore } from '../store/store';

export const onChangeReports = mutatorAction('onChangeReports', (reports: IReportSection[]) => {
  getPageStore().reports = reports;
});

export const onChangeSavedReports = mutatorAction('onChangeSavedReports', (savedReports: ISavedReportItem[]) => {
  const reports = getPageStore().reports;
  const myReportsSection = reports.find((section) => section.id === MY_REPORT_SECTION_ID) as IReportSection;
  myReportsSection.items = savedReports;
});

export const addToMyReports = mutatorAction('addToMyReports', (report: IReportItem) => {
  const store = getPageStore();
  const myReportsSection = store.reports.find((section) => section.id === MY_REPORT_SECTION_ID) as IReportSection;
  myReportsSection?.items.unshift(report);
});

export const changeReport = mutatorAction('changeReport', (report: IReportItem) => {
  const store = getPageStore();
  const section = store.reports.find((s) => s.items.some((i) => i.id === report.id));
  if (section) {
    const itemIndex = section.items.findIndex((i) => i.id === report.id);
    if (itemIndex !== -1) {
      section.items[itemIndex] = report;
    }
  }
});

export const clearUnsavedReports = mutatorAction('clearUnsavedReports', () => {
  const store = getPageStore();
  store.reports.forEach((section) => {
    section.items = section.items.filter((item) => item.isSaved);
  });
});

export const navigateToReportByName = action('navigateToReportByName', (reportName: string, history: History<unknown>) => ({
  reportName,
  history,
}));
